module.exports = __webpack_public_path__ + "img/renshou.113070f2.jpg";